import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { PageMetadataService } from '../shared/services/page-metadata.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  providers: [NgbCarouselConfig],
})
export class LoginComponent implements OnInit, OnDestroy {
  isCollapsed = true;
  public env = environment;

  responsiveOptions: any[] | undefined;

  images = [
    environment.assetUrl + '/login/slide1.jpg',
    environment.assetUrl + '/login/slide2.jpg',
    environment.assetUrl + '/login/slide3.jpg',
  ];

  title = ['Slide-1', 'Slide-2', 'Slide-3', 'Slide-4'];

  constructor(
    config: NgbCarouselConfig,
    private renderer: Renderer2,
    private authService: AuthService,
    private router: Router,
    private pageMetaData:PageMetadataService
  ) {
    config.interval = 5000;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = false;
    config.animation = true;
    config.showNavigationArrows = false;
    this.renderer.addClass(document.body, 'body-bg');
  }

  ngOnInit(): void {
    this.pageMetaData.setTitle('Login | OBP')
    this.authService.getLoggedInUser();
    if (this.authService.isAuthenticatedUser()) {
      this.router.navigate(['/home']);
    }
  }

  ssoLogin() {
    // location.href = '/api/auth/sso';
    location.href = `${environment.opbBackendHost}/api/auth/sso`;
    // this.router.navigate(['/home']);
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'body-bg');
  }
}
